import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { defaultOrQueryDate } from '../../utils/QueryParser'
import UnitChartView from './UnitChartView'
import * as TimeseriesActionCreators from '../../actions/timeseries'
import * as EventActionCreators from '../../actions/event'

class UnitChartContainer extends React.Component {
  static propTypes = {
    unitId: PropTypes.number.isRequired,
    timeseries: PropTypes.object.isRequired,
    timeseriesByUnit: PropTypes.object.isRequired,
    timeseriesActions: PropTypes.object.isRequired,
    events: PropTypes.object.isRequired,
    eventActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      timeseries: state.timeseries,
      timeseriesByUnit: state.timeseriesByUnit,
      events: state.events,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      timeseriesActions: bindActionCreators(TimeseriesActionCreators, dispatch),
      eventActions: bindActionCreators(EventActionCreators, dispatch),
    }
  }

  componentDidMount() {
    this.update()
  }

  componentDidUpdate() {
    this.update()
  }

  update() {
    const {
      unitId,
      timeseriesActions,
      eventActions,
      events,
    } = this.props
    timeseriesActions.listUnitTimeseries(unitId)
    const ts = this.timeseriesToChart()
    if (ts && !events[ts.id]) {
      eventActions.listEvents(ts.id)
    }
  }

  timeseriesToChart() {
    const {
      unitId, timeseries, timeseriesByUnit,
    } = this.props
    const tsIds = timeseriesByUnit[unitId] || []

    return tsIds.map((id) => (timeseries[id])).find((ts) => ts.name === 'energy/power' && ts.internal === false)
  }

  render() {
    const {
      events,
    } = this.props
    let timeseriesEvents = []
    const ts = this.timeseriesToChart()
    if (ts && ts.id) {
      timeseriesEvents = events[ts.id] || []
    }

    if (timeseriesEvents.length > 0) {
      const [from, to] = defaultOrQueryDate()
      return (
        <UnitChartView
          events={timeseriesEvents}
          timeseries={ts}
          size="half_height"
          timeMin={from}
          timeMax={to}
        />
      )
    }
    return null
  }
}

export default connect(
  UnitChartContainer.mapStateToProps,
  UnitChartContainer.mapDispatchToProps,
)(UnitChartContainer)
